import React from 'react';
import { 
  Ferry
} from 'mdi-material-ui';

export const getCustomActionIcon = (className) => <Ferry className={className} />;
